module.exports = __webpack_public_path__ + "static/media/step1-1.7465e088.png";